"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _FeeExchange = require("@cennznet/types/extrinsic/FeeExchange");

var _types = require("@plugnet/types");

var _util = require("@plugnet/util");

var _util2 = require("@cennznet/util");

var _Doughnut = require("./Doughnut");

var _ExtrinsicSignature = _interopRequireWildcard(require("./ExtrinsicSignature"));

// Copyright 2019 Centrality Investments Limited
// Copyright 2017-2019 @polkadot/types authors & contributors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// tslint:disable member-ordering no-magic-numbers

/**
 * @name Extrinsic
 * @description
 * Representation of an Extrinsic in the system. It contains the actual call,
 * (optional) signature and encodes with an actual length prefix
 *
 * {@link https://github.com/paritytech/wiki/blob/master/Extrinsic.md#the-extrinsic-format-for-node}.
 *
 * Can be:
 * - signed, to create a transaction
 * - left as is, to create an inherent
 */
class Extrinsic extends _types.Struct {
  constructor(value) {
    super(...Extrinsic.decodeExtrinsic(value || {}));
  }

  static decodeExtrinsic(value) {
    const defaultDef = {
      signature: _ExtrinsicSignature.default,
      method: _types.Method
    };

    if (Array.isArray(value) || (0, _util.isHex)(value)) {
      // Instead of the block below, it should simply be:
      // return Extrinsic.decodeExtrinsic(hexToU8a(value as string));
      const u8a = (0, _util.u8aToU8a)(value); // HACK 11 Jan 2019 - before https://github.com/paritytech/substrate/pull/1388
      // extrinsics didn't have the length, cater for both approaches

      const [offset, length] = _types.Compact.decodeU8a(u8a);

      const withPrefix = u8a.length === offset + length.toNumber();
      return Extrinsic.decodeExtrinsic(withPrefix ? u8a : _types.Compact.addLengthPrefix(u8a));
    } else if ((0, _util.isU8a)(value)) {
      const [offset, length] = _types.Compact.decodeU8a(value);

      const arr = value.subarray(offset, offset + length.toNumber());
      const [version] = arr;
      const definition = (0, _objectSpread2.default)({}, defaultDef);

      if ((0, _ExtrinsicSignature.checkDoughnut)(version)) {
        definition.doughnut = _Doughnut.OptionalDoughnut;
      }

      if ((0, _ExtrinsicSignature.checkFeeExchange)(version)) {
        definition.feeExchange = _FeeExchange.OptionalFeeExchange;
      }

      return [definition, arr];
    } else if (value instanceof _types.Method) {
      return [defaultDef, {
        method: value
      }];
    }

    const definition = (0, _objectSpread2.default)({}, defaultDef);

    if (value.doughnut) {
      definition.doughnut = _Doughnut.OptionalDoughnut;
    }

    if (value.feeExchange) {
      definition.feeExchange = _FeeExchange.OptionalFeeExchange;
    }

    return [definition, value];
  }
  /**
   * @description The arguments passed to for the call, exposes args so it is compatible with [[Method]]
   */


  get args() {
    return this.method.args;
  }
  /**
   * @description Thge argument defintions, compatible with [[Method]]
   */


  get argsDef() {
    return this.method.argsDef;
  }
  /**
   * @description The actual `[sectionIndex, methodIndex]` as used in the Method
   */


  get callIndex() {
    return this.method.callIndex;
  }
  /**
   * @description The actual data for the Method
   */


  get data() {
    return this.method.data;
  }
  /**
   * @description The length of the value when encoded as a Uint8Array
   */


  get encodedLength() {
    const length = this.length;
    return length + _types.Compact.encodeU8a(length).length;
  }
  /**
   * @description Convernience function, encodes the extrinsic and returns the actual hash
   */


  get hash() {
    return new _types.Hash((0, _util2.blake2AsU8a)(this.toU8a(), 256));
  }
  /**
   * @description `true` is method has `Origin` argument (compatibility with [[Method]])
   */


  get hasOrigin() {
    return this.method.hasOrigin;
  }
  /**
   * @description `true` id the extrinsic is signed
   */


  get isSigned() {
    return this.signature.isSigned;
  }
  /**
   * @description The length of the encoded value
   */


  get length() {
    return this.toU8a(true).length;
  }
  /**
   * @description The [[FunctionMetadata]] that describes the extrinsic
   */


  get meta() {
    return this.method.meta;
  }
  /**
   * @description The [[Method]] this extrinsic wraps
   */


  get method() {
    return this.get('method');
  }
  /**
   * @description The [[ExtrinsicSignature]]
   */


  get signature() {
    return this.get('signature');
  }

  get doughnut() {
    return this.get('doughnut') || new _Doughnut.OptionalDoughnut();
  }

  get feeExchange() {
    return this.get('feeExchange') || new _FeeExchange.OptionalFeeExchange();
  }
  /**
   * @description Add an [[ExtrinsicSignature]] to the extrinsic (already generated)
   */


  addSignature(signer, signature, nonce, era) {
    this.signature.addSignature(signer, signature, nonce, era);
    return this;
  }
  /**
   * @description append doughnut to Extrinsic
   */


  addDoughnut(doughnut) {
    (0, _util2.assert)(doughnut, 'doughnut is empty');
    this.set('doughnut', new _Doughnut.OptionalDoughnut(doughnut));
    this.signature.withDoughnut();
    return this;
  }
  /**
   * @description append fee exchange options to Extrinsic
   */


  addFeeExchangeOpt(feeExchangeOpt) {
    (0, _util2.assert)(feeExchangeOpt, 'feeExchangeOpt is empty');
    this.set('feeExchange', new _FeeExchange.OptionalFeeExchange(feeExchangeOpt));
    this.signature.withFeeExchange();
    return this;
  }
  /**
   * @description Sign the extrinsic with a specific keypair
   */


  sign(account, options) {
    this.signature.sign(this, account, options);
    return this;
  }
  /**
   * @description Returns a hex string representation of the value
   */


  toHex() {
    return (0, _util.u8aToHex)(this.toU8a());
  }
  /**
   * @description Converts the Object to JSON, typically used for RPC transfers
   */


  toJSON() {
    return this.toHex();
  }

  toPlain() {
    return super.toJSON();
  }

  toArray() {
    const arr = [this.signature];
    arr.push(this.method);

    if (this.doughnut.isSome) {
      arr.push(this.doughnut.unwrap());
    }

    if (this.feeExchange.isSome) {
      arr.push(this.feeExchange.unwrap());
    }

    return arr;
  }
  /**
   * @description Encodes the value as a Uint8Array as per the parity-codec specifications
   * @param isBare true when the value has none of the type-specific prefixes (internal)
   */


  toU8a(isBare) {
    const encoded = super.toU8a();
    return isBare ? encoded : _types.Compact.addLengthPrefix(encoded);
  }

}

exports.default = Extrinsic;